import { isValidIBAN, friendlyFormatIBAN } from 'ibantools';
import { sanitizeToAlphanumeric } from './sanitizeToAlphanumeric';

export function formatIbanForDisplay(value: string): string {
  return friendlyFormatIBAN(value) ?? value;
}

export function formatAccountNumberByNetworkForDisplay({
  networkId,
  accountNumber,
}: {
  networkId: string;
  accountNumber: string;
}) {
  switch (networkId) {
    case 'SEPA':
    case 'SEPA_INSTANT':
      return formatIbanForDisplay(accountNumber);
    default:
      return accountNumber;
  }
}

export function formatAccountNumberForDisplay({ type, value }: { type: string; value: string }) {
  if (type === 'IBAN') {
    return formatIbanForDisplay(value);
  }

  return value;
}

export function formatFiatAccountNumberForServer(value: string): string {
  return value ? sanitizeToAlphanumeric(value).toUpperCase() : '';
}

export function formatCryptoAccountNumberForServer(value: string): string {
  return value ? value.replace(/\s+/g, '') : '';
}

export function validateIban(value: string): boolean {
  const formatted = formatFiatAccountNumberForServer(value);
  if (!formatted) {
    return true;
  }

  return isValidIBAN(formatted);
}
